module.exports = __webpack_public_path__ + "img/mkinetikos-1.260dfec9.png";